import { createMD5, IHasher } from 'hash-wasm';

/**
 * Generate a file checksum used to verify the file between clients and backend.
 *
 * Accepts a hasher implementation to reuse across multiple invocations. Doing
 * so saves CPU cycles.
 */
export async function computeAttachmentFileChecksum(file: File, hasher?: IHasher): Promise<string> {
  const chunkSize = 1024 * 1024; // 1MB chunks

  // Allow reusing a previous hasher for efficiency.
  // NOTE: the hasher is not thread-safe because it tracks its own state.
  hasher = hasher ? hasher.init() : await createFileHasher();

  let offset = 0;

  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    const chunkBuffer = await chunk.arrayBuffer();
    hasher.update(new Uint8Array(chunkBuffer));

    offset += chunkSize;
  }

  return hasher.digest();
}

/**
 * Build the file checksum hasher that uses the agreed hashing algorithm
 * between clients and the backend.
 */
export async function createFileHasher(): Promise<IHasher> {
  const hasher = await createMD5();

  return hasher.init();
}
